import * as React from 'react'

const UserIcon = (props) => (
  <svg
    width={props.width}
    height={props.height}
    viewBox={'0 0 18 18'}
    {...props}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#a)" fill={props.fill}>
      <path d="M9.122 8.715h-.06a.407.407 0 0 0-.135 0C6.752 8.648 5.109 6.938 5.109 4.83A3.899 3.899 0 0 1 9.002.937a3.899 3.899 0 0 1 3.892 3.893 3.879 3.879 0 0 1-3.75 3.885h-.022Zm-.12-6.652A2.775 2.775 0 0 0 6.234 4.83c0 1.5 1.17 2.707 2.663 2.76.037-.008.142-.008.24 0a2.763 2.763 0 0 0 2.632-2.76 2.775 2.775 0 0 0-2.767-2.768ZM9.13 16.913c-1.47 0-2.947-.375-4.064-1.126-1.043-.69-1.613-1.635-1.613-2.662s.57-1.98 1.613-2.678c2.25-1.492 5.895-1.492 8.13 0 1.035.69 1.612 1.636 1.612 2.663s-.57 1.98-1.612 2.678c-1.125.75-2.595 1.125-4.065 1.125Zm-3.442-5.52c-.72.48-1.11 1.095-1.11 1.74 0 .637.398 1.252 1.11 1.725 1.868 1.252 5.018 1.252 6.885 0 .72-.48 1.11-1.096 1.11-1.74 0-.638-.397-1.253-1.11-1.726-1.867-1.244-5.017-1.244-6.885 0Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h18v18H0z" />
      </clipPath>
    </defs>
  </svg>
)

UserIcon.defaultProps = {
  width: 18,
  height: 18,
  fill: '#64748B'
}

export { UserIcon }
